import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { LicenseErrorCode, LicenseErrorPayload, LicenseErrorSource } from '@/utils/licenseError'

export interface LicenseErrorState {
  locked: boolean
  uniqueCode: LicenseErrorCode | null
  status: number | null
  message: string | null
  source: LicenseErrorSource | null
  occurredAt: number | null
}

export const initialLicenseErrorState: LicenseErrorState = {
  locked: false,
  uniqueCode: null,
  status: null,
  message: null,
  source: null,
  occurredAt: null,
}

const licenseErrorSlice = createSlice({
  name: 'licenseError',
  initialState: initialLicenseErrorState,
  reducers: {
    activateLicenseError(state, action: PayloadAction<LicenseErrorPayload>) {
      if (state.locked) {
        return
      }

      state.locked = true
      state.uniqueCode = action.payload.uniqueCode
      state.status = action.payload.status
      state.message = action.payload.message
      state.source = action.payload.source
      state.occurredAt = action.payload.occurredAt
    },
    clearLicenseError() {
      return initialLicenseErrorState
    },
  },
})

export const { activateLicenseError, clearLicenseError } = licenseErrorSlice.actions

export default licenseErrorSlice.reducer
